












import { Component, Vue } from "vue-property-decorator";
import ViewerPlugin from "@/plugins/viewer";
import { ConfigCreator } from "@/mixins/configurator";
import { mixins } from "vue-class-component";
import { GenericError, ViewerError } from "@/services/error_service";
import { EventBus } from "@/event-bus";
import { Stem } from "@/models/configurator/configurator_options";
import { StockMixin } from "@/mixins/stock";

@Component
export default class Configurator extends mixins(ConfigCreator, StockMixin) {
  protected loader: any | null = null;

  protected onGetStaticImages = async (callback: (images: string[]) => Promise<any>) => {
    const images = await this.getImages();
    callback(images);
  };

  created() {
    EventBus.$off("getStaticImages", this.onGetStaticImages);
    EventBus.$on("getStaticImages", this.onGetStaticImages);
    if (this.$route.path.includes("designer")) {
      this.loader = this.$loading.show(
        { opacity: 0.9 },
        {
          before: this.$createElement("h1", {
            domProps: { innerHTML: "Loading..." },
          }),
        }
      );
    }
  }

  beforeDestroy() {
    EventBus.$off("getStaticImages", this.onGetStaticImages);
  }

  protected async frameLoaded(): Promise<void> {
    ViewerPlugin.init(Vue);
    try {
      this.$viewer.SetAssetPath(process.env.VUE_APP_CDN_URL + "/sd");
      await this.transformDataForViewerAndStartApp();
      this.$viewer.addEventListener("viewer.loaded", (event) => {
        EventBus.$emit("ready"); // TLT_2023-05-22: this call doesn't fulfill...
        this.$emit("ready");
        if (this.loader) this.loader.hide();
      });
    } catch (err) {
      console.log(err);
      if (this.loader) this.loader.hide();
      ViewerError.redirect(err);
    }
  }

  protected async getImages(resolution?: {
    x: number;
    y: number;
  }): Promise<string[]> {
    let images: string[] = [];
    try {
      let res;
      if (resolution) {
        res = await this.$viewer.RenderStaticImage(resolution);
      } else {
        res = await this.$viewer.RenderStaticImage({ x: 600, y: 600 });
      }
      if (res) {
        images = res;
      } else {
        throw new Error("Error obtaining images");
      }
    } catch (err) {
      GenericError.popup(err.message);
    }
    return images;
  }
}
